// extracted by mini-css-extract-plugin
module.exports = {"Card":"UserRatingsPortalSetting_Card__3h2kg","Container":"UserRatingsPortalSetting_Container__TPgOB","RatingHeaderText":"UserRatingsPortalSetting_RatingHeaderText__2dUBM"};